import { render, staticRenderFns } from "./Service-barcode.vue?vue&type=template&id=51c3959b"
import script from "./Service-barcode.vue?vue&type=script&lang=js"
export * from "./Service-barcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports